angular.module('Itao.IndicatorMap').factory('ModalService', ['$uibModal', function($uibModal) {
  'use strict';

  /**
   * Default options for uiBootstrapModal
   *  @type {{size: string, templateUrl: string, controller: string}}
   */
  var defaultOptions = {
    size: 'lg',
    templateUrl: '',
    controller: 'CustomModalController'
  };

  /**
   *
   * @param {object} inputData object which contains the data which should be available in the modal
   * @param {object} options configuration object for the modal initialization
   * @returns {object} modalInstance
   */
  function createCustomModal(inputData, options) {
    var config = angular.extend(defaultOptions, options);
    return $uibModal.open({
      templateUrl: config.templateUrl,
      size: config.size,
      controller: config.controller,
      backdrop: config.backdrop ? config.backdrop : true,
      keyboard: !!config.keyboard,
      resolve: {
        data: function () {
          return inputData;
        }
      }
    });
  }

  return {
    createCustomModal: createCustomModal
  };

}]);
